import type { eference } from '@ctw/shared/api/fhir/resource-helper';
import type { Coverage } from 'fhir/r4';
import { gql } from 'graphql-request';
import type { GraphqlConnectionNode, GraphqlPageInfo } from '../client';
import { fragmentCoding, fragmentOrganization, fragmentPatient } from './fragments';

export interface CoverageConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<Coverage & { subscriber?: eference }>>;
}

export interface CoverageGraphqlResponse {
  CoverageConnection: CoverageConnection;
}

export const coverageQuery = gql`
  ${fragmentCoding}
  ${fragmentOrganization}
  ${fragmentPatient}

  query Coverage(
    $upid: ID!
    $cursor: String!
    $filter: CoverageFilterParams! = {}
    $sort: CoverageSortParams!
    $first: Int!
  ) {
    CoverageConnection(upid: $upid, after: $cursor, filter: $filter, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          resourceType
          meta {
            lastUpdated
            extension {
              url
              valueReference {
                reference
              }
            }
            tag {
              system
              code
            }
          }
          beneficiary {
            reference
          }
          class {
            type {
              text
              coding {
                ...Coding
              }
            }
            value
            name
          }
          order
          period {
            start
          }
          status
          type {
            text
            coding {
              ...Coding
            }
          }
          payor {
            display
          }
          relationship {
            coding {
              ...Coding
            }
          }
          subscriberId
          subscriber {
            reference
            resource {
              ...Patient
            }
          }
        }
      }
    }
  }
`;
